import { useState } from "react";
import { AdCampaign } from "../models/AdCampaign";
import * as web3 from "@solana/web3.js";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { useProgram } from "../utils/ProgramContext";
import { User } from "../models/User";

const styles: { [key: string]: React.CSSProperties } = {
    formContainer: {
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
        marginBottom: '20px',
    },
    input: {
        padding: '10px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        width: '100%',
        marginBottom: '10px',
    },
    select: {
        padding: '10px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        width: '100%',
        marginBottom: '10px',
    },
    button: {
        padding: '10px 20px',
        borderRadius: '4px',
        backgroundColor: 'black',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
    },
};



const RegisterAdCampaign: React.FC = () => {
    const [name, setName] = useState("");
    const [link, setLink] = useState("");
    const { program } = useProgram() || {};

    const { connection } = useConnection();
    const { publicKey, sendTransaction } = useWallet();

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (!publicKey) {
            alert("Please connect your wallet!");
            return;
        }

        handleTransactionSubmit();
    };

    const handleTransactionSubmit = async () => {
        if (!publicKey || !program) {
            alert("Please connect your wallet!");
            return;
        }

        const [adCampaignPda] = await AdCampaign.findAddress(publicKey, 1)
        const [userPda] = await User.findAddres(publicKey);

        const transaction = await program.methods.createAdCampaign(
            name, link
        ).accounts({
            adCampaign: adCampaignPda,
            user: userPda,
            signer: publicKey,
            systemProgram: web3.SystemProgram.programId
        }).transaction()

        try {
            const txid = await sendTransaction(transaction, connection);
            alert(
                `Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
            );
            console.log(
                `Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
            );
        } catch (e) {
            console.log(JSON.stringify(e));
            alert(JSON.stringify(e));
        }
    };
    return (
        <main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
            <div className="flex items-center">
                <h1 className="text-lg font-semibold md:text-2xl">Register Ad Campaign</h1>
            </div>
            <div className="flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm">
                <div className="flex flex-col items-center gap-1 text-center">
                    <form style={styles.formContainer} onSubmit={handleSubmit}>
                        {/* ... Similar structure as CreateProviderForm but with fields for an advertisement */}
                        <input style={styles.input} type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                        <input style={styles.input} type="text" placeholder="Link" value={link} onChange={(e) => setLink(e.target.value)} />
                        <button style={styles.button} type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </main>
    );
}

export default RegisterAdCampaign

